module.exports = __webpack_public_path__ + "img/Profilprofi.490c2f42.svg";